import { orchestrator } from 'satcheljs';
import { updateFolderIdsIfNeeded } from '../actions/internalActions';
import {
    getAndUpdateActualFolderId,
    calendarFolderIdNeedsUpdate,
} from '../selectors/calendarCacheSelectors';

orchestrator(updateFolderIdsIfNeeded, actionMessage => {
    actionMessage.calendarIds
        .filter(calendarFolderIdNeedsUpdate)
        .forEach(getAndUpdateActualFolderId);
});
